module.exports = __webpack_public_path__ + "static/media/metamask-icon.e2f0aae8.svg";